import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { BehaviorSubject, Observable, filter } from 'rxjs';
import { ICompany } from '../models/Company';
import { IUser } from '../models/User';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CreateCompanyService {
  private myCompanySubject: BehaviorSubject<ICompany> = new BehaviorSubject(null);
  public myCompany: Observable<ICompany> = this.myCompanySubject.asObservable().pipe(filter((at) => at !== null));
  private myInfoSubject: BehaviorSubject<IUser> = new BehaviorSubject(null);
  public myInfo: Observable<IUser> = this.myInfoSubject.asObservable().pipe(filter((at) => at !== null));

  constructor(private authService: AuthService, private http: HttpClient) {
    this.authService.currentUser$.subscribe((u) => {
      if (u) {
        this.http.get(`${environment.endpoints.basePath}/company/${u.company_id}/`).subscribe((c: ICompany) => {
          this.myCompanySubject.next(c);
        });
        this.myInfoSubject.next(u);
      }
    });
  }

  updateUserName(userData: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .patch(`${environment.endpoints.basePath}/users/${this.authService.currentUser.id}/`, {
          first_name: userData.first_name,
          last_name: userData.last_name
        })
        .subscribe((response) => {
          resolve(response);
        });
    });
  }

  updateUserCompanyName(companyName: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .patch(`${environment.endpoints.basePath}/company/${this.authService.currentUser.company_id}/`, {
          name: companyName
        })
        .subscribe((response) => {
          resolve(response);
        });
    });
  }
}
